// extracted by mini-css-extract-plugin
export default {"drawer":"drawer_drawer__wRRec","appear":"drawer_appear__mBpJm","maxHeight":"drawer_maxHeight__5oHkN","opacity-transition":"drawer_opacity-transition__GT0dl"};